import { blackColors, primaryColor } from 'assets/jss/material-dashboard-pro-react';

const iconButton = {
	container: {
		display: 'inline-flex',
		flexDirection: 'column',
		textAlign: 'center',
	},
	label: {
		fontSize: '15px',
		marginTop: '8px',
		lineHeight: '1.07',
		color: primaryColor[0],
	},
	disabled: {
		color: blackColors[3],
	},
	button: {
		paddingTop: 0,
		paddingBottom: 0,
	},
};

export default iconButton;
